var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHospitalCloseIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 51,
    height: 52,
    rx: 25.5,
    fill: "white",
    fillOpacity: 0.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0467 24.7543C24.0529 25.7605 24.0529 27.3919 23.0467 28.3982L18.3912 33.0536C18.1397 33.3052 18.1397 33.713 18.3912 33.9646C18.6428 34.2162 19.0506 34.2162 19.3022 33.9646L23.9576 29.3092C24.9639 28.3029 26.5953 28.3029 27.6016 29.3092L32.0555 33.7631C32.3071 34.0147 32.715 34.0147 32.9665 33.7631C33.2181 33.5116 33.2181 33.1037 32.9665 32.8521L28.5126 28.3982C27.5063 27.3919 27.5063 25.7605 28.5126 24.7543L32.967 20.2998C33.2185 20.0483 33.2185 19.6404 32.967 19.3889C32.7154 19.1373 32.3076 19.1373 32.056 19.3889L27.6016 23.8433C26.5953 24.8495 24.9639 24.8495 23.9576 23.8433L19.3017 19.1874C19.0502 18.9358 18.6423 18.9358 18.3908 19.1874C18.1392 19.4389 18.1392 19.8468 18.3908 20.0984L23.0467 24.7543Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHospitalCloseIcon);
export default __webpack_public_path__ + "static/media/hospitalCloseIcon.e8fb4da09c94484741d149b89da7834a.svg";
export { ForwardRef as ReactComponent };